module.exports = __webpack_public_path__ + "static/media/signage-indoor-img79.46a8f6cd.jpg";